import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ViewType from "./routes/ViewType";
import UnitPlanPreviewRoute from "./routes/UnitPlanPreviewRoute";

export default store => ({
  path: "course/:courseId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "curriculum-maps" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [ViewType(store), UnitPlanPreviewRoute(store)],
});
